import { Transaction } from '@algoan/dashboard/model';
import { selectDate } from '@algoan/dashboard/utils';

export const sortTransactionsByDateAndId = (
  transactionA: Pick<Transaction, 'dates' | 'id'>,
  transactionB: Pick<Transaction, 'dates' | 'id'>,
): number => {
  const timeA = Date.parse(selectDate(transactionA.dates));
  const timeB = Date.parse(selectDate(transactionB.dates));

  // in case the dates are the same, we sort by id to keep a consistent sort
  if (timeA === timeB) {
    if (transactionA.id < transactionB.id) {
      return -1;
    }
    if (transactionA.id > transactionB.id) {
      return 1;
    }
    return 0;
  }

  return timeB - timeA;
};
